// extracted by mini-css-extract-plugin
module.exports = {"root":"post-module--root--6fyhV","headerLink":"post-module--header-link--3yuST"};